import AuthLayout from "@/components/layouts/auth-layout";
import { renderSignupView } from "@/components/organisms/forms/auth/render-signup-view";
import { Locales } from "@/lib/i18n";
import { __ } from "@/lib/i18n/functions";
import { actions } from "@/locales/segment";
import { notFound } from "next/navigation";

interface SignupProps {
  resolution: Resolution;
}

export const isUserVerifyRoute = (locale: Locales, slug: string) => {
  const localeActions = actions[locale as keyof typeof actions];
  if (!localeActions) return false;
  return localeActions["verify"] === slug;
};

export const isUserConfirmRoute = (locale: Locales, slug: string) => {
  const localeActions = actions[locale as keyof typeof actions];
  if (!localeActions) return false;
  return localeActions["confirm"] === slug;
};

const Signup = ({ resolution }: SignupProps) => {
  const [route] = resolution.slugs;
  const viewComponent = renderSignupView(resolution);

  if (viewComponent === null) return notFound();

  return (
    <AuthLayout route={route} locale={resolution.locale}>
      {viewComponent}
    </AuthLayout>
  );
};

Signup.generateMetadata = async (resolution: Resolution) => {
  return {
    title: __("Sign Up", resolution.locale),
  };
};

export default Signup;
